import React from "react";
import { Home } from "./components/Home.js";
import './scss/app.scss'

export const App = () => {
  return (
    <Home />
  );
};
